import api from '@/services/api'

export default {
  auth(username, password) {
    return api.post('/admin/auth', { username, password })
  },

  getUserData() {
    return api.get('/admin')
  },
}